export default __webpack_public_path__ + "static/pic01-8e4b4a2eaead57f7a88b7d638e45e6cb.jpg";